import React from 'react';
import { Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { TranslationKeys } from 'app/translations';
import type { UploadedFileDetail } from '../../../Services';
import {
  InfoCardStyled,
  CardHeaderBandStyled,
  CardIconCircleStyled,
  CardBodyStyled,
  CountRowStyled,
  CountLabelStyled,
  FileListWrapperStyled,
  FileRowStyled,
  FileNameStyled,
  FileUploadedAtStyled,
} from '../FileUploadCleanupPage.styles';

const formatUploadedAt = (value: string | null): string => {
  if (!value) return '—';
  const d = new Date(value);
  return isNaN(d.getTime()) ? value : d.toLocaleString();
};

type FileListCardProps = { files: UploadedFileDetail[]; color: string };

export const FileListCard = ({ files, color }: FileListCardProps) => (
  <InfoCardStyled elevation={0}>
    <CardHeaderBandStyled bandcolor={color}>
      <CardIconCircleStyled bandcolor={color}>
        <FontAwesomeIcon icon={faFileLines} />
      </CardIconCircleStyled>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '0.72rem',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color,
          lineHeight: 1.2,
        }}
      >
        <FormattedMessage id={TranslationKeys.adminPanel_undoUploadedFile_preview_section_fileData} />
      </Typography>
    </CardHeaderBandStyled>
    <CardBodyStyled>
      {files.length === 0 ? (
        <CountRowStyled>
          <CountLabelStyled>
            <FormattedMessage id={TranslationKeys.adminPanel_undoUploadedFile_preview_uploadedFileDetails_empty} />
          </CountLabelStyled>
        </CountRowStyled>
      ) : (
        <FileListWrapperStyled>
          {files.map((file, idx) => (
            <FileRowStyled key={`${file.fileName}-${file.uploadedAt || idx}`}>
              <FileNameStyled>{file.fileName}</FileNameStyled>
              <FileUploadedAtStyled>{formatUploadedAt(file.uploadedAt)}</FileUploadedAtStyled>
            </FileRowStyled>
          ))}
        </FileListWrapperStyled>
      )}
    </CardBodyStyled>
  </InfoCardStyled>
);
